"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assign;
/*  weak */
function assign(base) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return args.reduce(function (extend, obj) {
    for (var property in obj) {
      var value = obj[property];
      if (extend[property] instanceof Object && value instanceof Object) {
        extend[property] = assign({}, extend[property], value);
      } else {
        extend[property] = value;
      }
    }
    return extend;
  }, base);
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/utils/assign.js
// module id = 445
// module chunks = 0